import moment from 'moment';
import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestReports() {
  return {
    type: Constants.REQUEST_REPORTS
  };
}
export function receiveReports(json, error) {
  return {
    type: Constants.RECEIVE_REPORTS,
    data: json,
    error
  };
}

export function modifyReportsFilter(filter) {
  return {
    type: Constants.MODIFY_REPORTS_FILTER,
    filter
  };
}

export function urlForFilter(filter) {
  let url = 'ecs/api/report/selection_click';
  if (filter.startDate && filter.endDate) {
    const startOffset = moment(filter.startDate).utcOffset();
    const endOffset = moment(filter.endDate).utcOffset();
    const params = {
      start_date: moment(filter.startDate)
        .add(-startOffset, 'm')
        .startOf('day')
        .toISOString(),
      end_date: moment(filter.endDate)
        .add(-endOffset, 'm')
        .endOf('day')
        .toISOString()
    };
    const qs = Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&');
    return `${url}?${qs}`;
  }
  return undefined;
}

export function getReports(filter, options = {}) {
  const path = urlForFilter(filter);
  return new Endpoint(path, requestReports, receiveReports)
    .withOptions(options)
    .call();
}
